import { BaseLookupModel, PaginationFilterRequest } from "./core.model";

export interface BrandGear {
    id: number;
    name: string;
    coverImageUrl?: string;
    sportBrandId: number;
    type: GearTypeEnum;
    sportBrand?: BaseLookupModel
}

export interface UpsertBrandGear {
    id?: number;
    name?: string;
    coverImageUrl?: string;
    sportBrandId?: number;
    type?: GearTypeEnum;
}

export class BrandGearPaginationFilterRequest extends PaginationFilterRequest{  
    sportBrandId? : number;
    type? : GearTypeEnum;
}

export enum GearTypeEnum
{
    Shoe = 1,
    Shirt = 2,
}

export const GearTypeList = [
    {value: 1, label: "Shoe"},
    {value: 2, label: "Shirt"},
];